<script setup lang="ts">
import { computed } from 'vue'

import type { PlatformLogoProps } from './types'

import { Icon } from '@/shared/ui/icon'

const props = withDefaults(defineProps<PlatformLogoProps>(), {
  size: 25,
  channel: null,
  alt: '',
  showText: false,
})

const label = computed(() => props.channel || props.platform)
const imageStyle = computed(() => ({
  width: `${props.platform.toLowerCase() === 'apple search ads' ? 40 : props.size}px`,
  height: `${props.size}px`,
}))
</script>

<template>
  <img
    v-if="src && platform.toLowerCase() !== 'none'"
    class="ui-platform-logo inline-block max-w-full flex-none object-contain"
    :src="src"
    :alt="alt"
    :style="imageStyle"
    :data-platform="platform"
    :data-channel="channel || undefined"
  />
  <span v-else-if="showText" class="ui-platform-logo__text text-fg font-sans capitalize">
    {{ label }}
  </span>
  <Icon
    v-else-if="platform.toLowerCase() !== 'none'"
    name="circle-question"
    :size="size"
    v-bind="alt ? { label: alt } : {}"
  />
</template>
